export const SORT = 'SORT';

export const FETCH_INVOICE = 'FETCH_INVOICE';

export const FETCH_INVOICE_IS_PENDING = 'FETCH_INVOICE_IS_PENDING';

export const FETCH_INVOICE_IS_ERROR = 'FETCH_INVOICE_IS_ERROR';

export const FETCH_INVOICE_UNPAID = 'FETCH_INVOICE_UNPAID';

export const FETCH_INVOICE_UNPAID_IS_PENDING = 'FETCH_INVOICE_UNPAID_IS_PENDING';

export const FETCH_INVOICE_UNPAID_IS_ERROR = 'FETCH_INVOICE_UNPAID_IS_ERROR';

export const FETCH_INVOICE_BY_ID = 'FETCH_INVOICE_BY_ID';

export const FETCH_INVOICE_BY_ID_IS_PENDING = 'FETCH_INVOICE_BY_ID_IS_PENDING';

export const FETCH_INVOICE_BY_ID_IS_ERROR = 'FETCH_INVOICE_BY_ID_IS_ERROR';

export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE';

export const DOWNLOAD_INVOICE_IS_PENDING = 'DOWNLOAD_INVOICE_IS_PENDING';

export const DOWNLOAD_INVOICE_IS_ERROR = 'DOWNLOAD_INVOICE_IS_ERROR';

export const RESET_INVOICE_STATE = 'RESET_INVOICE_STATE';
